import { Reveal } from "@/components/motion/Reveal";
import { CtaButton } from "@/components/brand/CtaButton";

export const CtaBand = ({ eyebrow = "Partnerships", title = "Let's Build What's Next.", text, primary, secondary, testid = "cta-band" }) => (
  <section className="grain relative overflow-hidden bg-plum py-24 sm:py-32" data-testid={testid}>
    <div aria-hidden="true" className="pointer-events-none absolute -right-32 -top-32 h-[480px] w-[480px] rounded-full border border-gold/20" />
    <div aria-hidden="true" className="pointer-events-none absolute -right-10 -top-10 h-[320px] w-[320px] rounded-full border border-gold/30" />
    <div aria-hidden="true" className="pointer-events-none absolute -bottom-40 left-1/4 h-[420px] w-[420px] rounded-full bg-plum-3/50 blur-[120px]" />
    <div className="shell relative z-[2]">
      <div aria-hidden="true" className="hairline-gold h-px w-full max-w-md" />
      <Reveal as="p" className="eyebrow mt-10 text-gold-light">{eyebrow}</Reveal>
      <Reveal as="h2" delay={0.05} className="mt-6 max-w-4xl font-display text-[2.6rem] font-light leading-[1.02] tracking-[-0.02em] text-white sm:text-6xl lg:text-7xl">
        {title}
      </Reveal>
      {text && <Reveal as="p" delay={0.1} className="mt-8 max-w-2xl text-base leading-relaxed text-white/80 md:text-lg">{text}</Reveal>}
      <Reveal delay={0.15} className="mt-10 flex flex-col gap-3 sm:flex-row">
        {primary && <CtaButton to={primary.to} testid={`${testid}-primary`}>{primary.label}</CtaButton>}
        {secondary && <CtaButton to={secondary.to} variant="outline" testid={`${testid}-secondary`}>{secondary.label}</CtaButton>}
      </Reveal>
    </div>
  </section>
);
